import { Box, Grid, Typography } from "@mui/material";

const ChannelsList = ({ selectedChannels }) => {
  //console.log(selectedChannels);
  return (
    <Box sx={{ my: 2, px: 4, py: { xs: 2, md: 4 } }}>
      {selectedChannels?.length > 0 ? (
        <Grid container spacing={4} columns={{ xs: 4, lg: 12 }}>
          <Grid
            item
            xs={4}
            sm={selectedChannels?.length > 50 ? 4 : 8}
            lg={selectedChannels?.length > 50 ? 8 : 12}
          >
            <Box>
              <Typography
                sx={{
                  bgcolor: "primary.main",
                  px: 1,
                  py: 0.5,
                  mb: 1.5,
                }}
                variant="h3"
              >
                TV Channels ({(selectedChannels?.length > 50) ? selectedChannels?.length - 50 : selectedChannels?.length})
              </Typography>
              <Box sx={{ px: 1, pb: 2.5, bgcolor: "#303137", borderRadius: 1 }}>
                <Grid container spacing={1}>
                  {selectedChannels
                    ?.slice(
                      0,
                      selectedChannels?.length > 50
                        ? selectedChannels?.length - 50
                        : undefined
                    )
                    .map((channel) => {
                      return (
                        <Grid
                          key={channel?.id}
                          item
                          xs={6}
                          sm={4}
                          xl={3}
                          height="25px"
                        >
                          <Box>
                            <Typography
                              noWrap
                              sx={{
                                px: 0.5,
                                fontSize: { xs: 14, md: 16 },
                                cursor: "pointer",
                                "&:hover": {
                                  backgroundColor: "secondary.main",
                                },
                              }}
                              color="info"
                            >
                              {channel?.channelName}
                            </Typography>
                          </Box>
                        </Grid>
                      );
                    })}
                </Grid>
              </Box>
            </Box>
          </Grid>
          {selectedChannels?.length > 50 && (
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <Box>
                <Typography
                  sx={{
                    bgcolor: "primary.main",
                    px: 1,
                    py: 0.5,
                    mb: 1.5,
                  }}
                  variant="h3"
                >
                  Music Channels (50)
                </Typography>

                <Box
                  sx={{ px: 1, pb: 2.5, bgcolor: "#303137", borderRadius: 1 }}
                >
                  <Grid container spacing={1}>
                    {selectedChannels
                      ?.slice(selectedChannels?.length - 50)
                      ?.map((channel, index) => (
                        <>
                          <Grid
                            key={channel?.id}
                            item
                            xs={6}
                            sm={4}
                            lg={12}
                            xl={6}
                            height="25px"
                          >
                            <Box>
                              <Typography
                                noWrap
                                sx={{
                                  px: 0.5,
                                  fontSize: { xs: 14, md: 16 },
                                  cursor: "pointer",
                                  "&:hover": { backgroundColor: "#ff6600" },
                                }}
                                color="info"
                              >
                                {channel?.channelName}{" "}
                              </Typography>
                            </Box>
                          </Grid>
                        </>
                      ))}
                  </Grid>
                </Box>
              </Box>
            </Grid>
          )}
        </Grid>
      ) : null}
    </Box>
  );
};

export default ChannelsList;
